import React from 'react';

import { css, keyframes } from '@emotion/css';
import { GRAY500 } from '../../../../domain/colors';

const skeletonLoading = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const styles = {
  flex: {
    display: 'flex',
  },
  gridList: css`
    border-radius: 0 0 8px 8px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: 54px;
    grid-column-gap: 15px;
    z-index: 4;
    @media only screen and (min-width: 565px) {
      grid-template-rows: 72px;
      grid-template-columns: repeat(2, 1fr);
      grid-row-gap: 15px;
    }
    @media only screen and (min-width: 780px) {
      grid-template-columns: repeat(3, 1fr);
    }
  `,
  listitemButton: {
    display: 'flex',
    fontSize: '14px',
    justifyContent: 'space-between',
    lineHeight: '18px',
    minHeight: '54px',
    whiteSpace: 'normal',
    border: 'none',
    borderRadius: 0,
    padding: 0,
    paddingRight: '20px',
    '@media (min-width: 565px)': {
      display: 'flex',
      minHeight: '72px',
      fontSize: '16px !important',
      lineHeight: `22px !important`,
      border: `1px solid ${GRAY500}`,
      borderRadius: '4px',
      height: 72,
      padding: '16px',
      paddingRight: '40px',
    },
  },
  listItem: css`
    @media only screen and (max-width: 565px) {
      &:not(:last-child) {
        border-bottom: 1px solid ${GRAY500};
      }
    }
  `,
  loader: css`
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: ${skeletonLoading} 2s infinite;
  `,
  text: css`
    border-radius: 5px;
    width: 90%;
    height: 18px;
  `,
  icon: css`
    width: 9px;
    height: 9px;
    border-radius: 50%;
  `,
  title: css`
    border-radius: 10px;
    width: 300px;
    height: 36px;
    @media only screen and (max-width: 565px) {
      height: 32px;
    }
  `,
  annotationCounter: css`
    margin-left: 16px;
    border-radius: 200px;
    width: 18px;
    height: 16px;
  `,
};

const LoadingBenefitCard = () => {
  return (
    <div role='listitem' className={css(styles.listItem)}>
      <div className={`grid grid-flex grid-align-center ${css(styles.listitemButton as any)}`}>
        <div className={`${styles.text} ${styles.loader}`} />
        <div className={`${styles.text} ${styles.icon}`} />
      </div>
    </div>
  );
};

export const LoadingBenefitPageContent = () => {
  return (
    <div role='status' className='BenefitsList'>
      <div
        role='heading'
        aria-level={2}
        className={`${css(
          styles.flex,
        )} grid-align-center palm-margin-bottom-xl margin-bottom-l vertical-center-container`}
      >
        <span className={`${styles.title} ${styles.loader}`} />
        {<span className={`${styles.annotationCounter} ${styles.loader}`} />}
      </div>
      <div role='list' aria-labelledby='benefitsFilters.headline' className={styles.gridList}>
        {new Array(5).fill(null).map((_, index) => (
          <LoadingBenefitCard key={index} />
        ))}
      </div>
    </div>
  );
};
